import { numberToPrettyString } from '@cian/utils';

export const formatProjectsPrice = (startPrice: number) => {
  return `от ${numberToPrettyString(startPrice)} ₽`;
};
